import { Injectable } from '@angular/core';
import { GlobalService } from './global.service';

@Injectable()
export class TimeGridService {
    timeGridInfo = (data, callback) => this.globalService.mountResource('GET', { url: '/timegrid' }, data, callback);

    constructor(protected globalService: GlobalService) { }
}
